/* eslint-disable */
if (window.injected_webpack_public_path) {
  __webpack_public_path__ = window.injected_webpack_public_path;
}

// for production builds, this global variable is set to the location of the /dist folder, so that webpack knows where to load chunks from